export function isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

export function isAndroid() {
  const regex = /Android/i;
  return regex.test(navigator.userAgent);
}

export function isIphone() {
  const regex = /iPhone/i;
  return regex.test(navigator.userAgent);
}
